import * as types from './mutation-types';
import initialState from './initialState';

export default {
  /**
   * stateを初期化
   * @param {*} state
   */
  // eslint-disable-next-line no-unused-vars
  [types.INIT_STATE](state) {
    state = Object.assign({}, initialState);
  },

  [types.SET_SIGNUP_TOKEN](state, payload) {
    state.signupToken = payload;
  },

  [types.SET_CURRENT_CAMPAIGN](state, payload) {
    state.current.campaign = payload;
  },

  [types.SET_APPLICANT](state, payload) {
    state.me = payload;
  },

  [types.SET_API_ENUMS](state, payload) {
    state.apiEnums = payload;
  }
};
